import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { Container } from "../theme/common";
import { SPACING } from "../theme/palette";
const BreadcrumbsStyle = styled("nav")(({ theme }) => ({
    "ol": {
        "display": "flex",
        "li": {
            "a": {
                "color": "currentColor",
                "fontWeight": "bold",
                "textTransform": "capitalize",
            },
            "a[aria-current='page']": {
                "color": theme.palette.primary.main,
            },
            "color": theme.palette.grey[900]
        },
        "li + li::before": {
            "content": "'\\2015'",
            "display": "inline",
            "paddingInline": SPACING.spacexs,
        },
        "listStyle": "none",
        "marginBlock": "0",
        "paddingInlineStart": "0",
        "paddingTop": "15px",
    },
}));
const Breadcrumbv2Component = (props) => {
    const { breadcrumbdata } = props;
    return (_jsx(ThemeProvider, { children: _jsx(Container, { children: _jsx(BreadcrumbsStyle, Object.assign({ "aria-label": "Breadcrumb" }, { children: _jsx("ol", { children: breadcrumbdata.map((item, index) => (_jsx("li", { children: _jsx("a", Object.assign({ "aria-current": index === breadcrumbdata.length - 1 ? "page" : false, href: item.url }, { children: _jsx("span", { dangerouslySetInnerHTML: { "__html": item.name } }) })) }, index))) }) })) }) }));
};
const breadcrumbV2 = (renderableData) => renderIdentifierGeneric(Breadcrumbv2Component, renderableData);
export { breadcrumbV2 };
